// extracted by mini-css-extract-plugin
export default {"wrapper":"home_wrapper__4KHbd","hero":"home_hero__zWzxD","logo":"home_logo__xcvpq"};